var map = {
	"./1.webp": 51185,
	"./10.webp": 12975,
	"./17.webp": 74194,
	"./3.webp": 57783,
	"./4.webp": 19258,
	"./5.webp": 33285,
	"./6.webp": 94360,
	"./7.webp": 79707,
	"./8.webp": 39598,
	"./9.webp": 9321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78868;